module.exports = __webpack_public_path__ + "img/big_1.e42eb286.jpeg";